module.exports = __webpack_public_path__ + "img/resized-APP-0009-1.d9a45e9a.png";